// <s-linger> — notices when a shopper pauses on a product card. When at least 60% of the
// card stays in view for 1.2s (or the pointer hovers it), toggles .is-lingering so CSS can
// play a shine sweep and a beating heart. Leaving the viewport resets it so it can replay.
// Purely presentational; respects reduced motion through CSS. One component per file.
class SLinger extends HTMLElement {
  #observer = null;
  #timer = 0;
  #ac = null;

  connectedCallback() {
    this.#ac = new AbortController();
    const signal = this.#ac.signal;
    this.addEventListener("pointerenter", () => this.#start(250), { signal });
    this.addEventListener("pointerleave", () => this.#stop(), { signal });

    this.#observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio >= 0.6) this.#start(1200);
        else this.#stop();
      },
      { threshold: [0, 0.6] },
    );
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#ac?.abort();
    this.#observer?.disconnect();
    clearTimeout(this.#timer);
  }

  #start(delay) {
    clearTimeout(this.#timer);
    this.#timer = setTimeout(() => this.classList.add("is-lingering"), delay);
  }

  #stop() {
    clearTimeout(this.#timer);
    this.classList.remove("is-lingering");
  }
}

if (!customElements.get("s-linger")) customElements.define("s-linger", SLinger);
